import { createStore } from 'satcheljs';
import PremiumStore from './schema/premiumStore';
import { SubscriberType } from './schema/subscriberType';
import LoadState from './schema/loadState';

const premiumStoreData: PremiumStore = {
    domainState: {
        loadState: LoadState.Uninitialized,
        isDomainCreated: false,
        isValid: false,
        domainName: '',
        isRemovingDomain: false,
        isDomainRemoved: false,
        isValidatingDomain: false,
        domainPurchaseDate: null,
        dnsRecordValue: '',
    },
    secondarySubscribersInfo: [],
    userInfo: {
        firstName: '',
        lastName: '',
        emailAddress: '',
        prosumerEmailAddress: '',
        isProsumerConsumerMailbox: false,
        isRemovingEmailAddress: false,
        safeLinksEnabled: false,
    },
    userInfoLoadState: LoadState.Uninitialized,
    subscriberType: SubscriberType.Unknown,
    deleteErrorCode: '',
    legacyPremiumUserDomainState: {
        loadState: LoadState.Uninitialized,
        authCode: '',
        locked: false,
        privacy: false,
        isTransferredToGoDaddy: false,
    },
    legacyPremiumTenant: {
        TenantName: '',
        MxVerified: -1,
        SubscriptionStatus: -1,
        DomainPurchaseType: -1,
        DNSStatus: -1,
        DomainPurchaseDate: null,
    },
};

const store = createStore<PremiumStore>('premiumStore', premiumStoreData)();
export default store;
